<fr-carousel>
  <ng-template FrSlide *ngFor="let image of images">
    <img class="img-fluid" [src]="image">
  </ng-template>
</fr-carousel>
